import React from "react";
import { connect } from "react-redux";
import { openPage } from "Pub/js/superJump";
import { langCheck } from "Pub/js/utils";
import { getStore, setStore } from "Pub/js/storageUtils";
import Ajax from "Pub/js/ajax";
import platform from "Pub/js/platform";
import { changeError } from "Store/appStore/action";

import './errorCentorIcon.less';

const { NCDiv, NCTooltip } = platform.base;
/**
 * 错误中心入口——头部icon
 */
let timer1 = 0;
class ErorrCentorIcon extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            total: 0,
            containerHeight: 333,
            singleLiHeight: 65,
            pageSize: 10,
            loaded: false, // 当前是否已经加载数据
            visable: false,
            errorlist: [],
            errorlistLength: '',
            lastscrollTop: 0,// 滚动条上次高度
            timer: 0, // 防抖定时器
            requestMoreFlag: true,
            pageIndex: 1,
            requestId: '',
            merge: false
        }
        // 初始化拉取数据
        this.loadGridCount();
    }

    // 显示下拉
    showVisable() {
        // 给页面上添加一个遮罩  解决iframe内部点击导致不能触发的问题
        // 还有一种方案是给iframe添加时间  具体参考 旁边的message组件
        let $maskDOM = document.querySelector('.error-center-pop-mask');
        if (!$maskDOM) {
            let $mask = document.createElement('div');
            $mask.className = 'error-center-pop-mask';
            document.body.appendChild($mask);
        } else {
            $maskDOM.style.display = "block";
        }


        if (!this.state.loaded) { // 当前是否已经加载数据
            this.setState({ visable: true, errorlist: [], errorlistLength: '', lastscrollTop: 0, timer: 0, requestMoreFlag: true, pageIndex: 1 }, (prev) => {
                this.loadgrid();
                // this.refs.erroriconlistInner.focus();
            });
        } else { // 加载后展示隐藏·和显示
            this.setState({ visable: true }, () => {
                // this.refs.erroriconlistInner.focus();
            });
        }
    }

    clearMask() {
        let $maskDOM = document.querySelector('.error-center-pop-mask');
        $maskDOM && ($maskDOM.style.display = 'none');
    }

    hideVisable() {
        this.clearMask();
        this.setState((prev) => ({ visable: false }), () => {
            // this.clearMask();
        });
    }

    handeleSkipPage = (uri, param) => {
        // this.refs.erroriconlistInner.blur();
        // console.log(window.location.hash.indexOf(uri), uri, window.location.hash);
        if (!~window.location.hash.indexOf(uri)) {
            openPage(uri, true, param, ["b1", "b2", "b3", "ifr"]);
            setTimeout(() => {
                this.hideVisable();
            });
        }

        // this.props.changeDrawer(false);
    };

    // 获取数目
    loadGridCount(callback, errorCallback) {
        this.state.merge && Ajax({
            url: '/nccloud/platform/fixdata/CountFixDataAction.do',
            data: {},
            loading: false,
            info: {
                name: langCheck(
                    "0000PUB-000105"
                ) /* 国际化处理： 首页*/,
                action: langCheck(
                    "0000PUB-000364"
                ) /* 国际化处理： 首页加载*/,
                appcode: "10220PLOGG"
            },
            success: (result) => {
                if (result.data.success) {
                    this.setState({
                        total: result.data.data || 0,
                        loaded: false
                    });
                }
                if (Object.prototype.toString.call(callback) == "[object Function]") {
                    callback();
                }
            },
            error: (res) => {
                console.log(res, '正在测试接口！');
                if (Object.prototype.toString.call(errorCallback) == "[object Function]") {
                    errorCallback();
                }
            }
        });
    }


    // 表格数据请求
    loadgrid(callback, errorCallback) {
        let data = {};

        data.start = this.state.pageIndex + '';
        data.pageSize = this.state.pageSize + '';
        data.datetype = 'all';
        this.state.requestId = Ajax({
            url: '/nccloud/platform/fixdata/ListFixDataAction.do',
            data: data,
            info: {
                name: langCheck(
                    "0000PUB-000105"
                ) /* 国际化处理： 首页*/,
                action: langCheck(
                    "0000PUB-000364"
                ) /* 国际化处理： 首页加载*/,
                appcode: "10220PLOGG"
            },
            success: (result) => {
                if (result.data.success) {
                    if (result.data.data.data) {
                        for (var i = 0; i < result.data.data.data.length; i++) {
                            if (result.data.data.data[i]['timegap'] == 0) {
                                result.data.data.data[i]['timewidth'] = langCheck(
                                    "0000PUB-000358"
                                )
                            }
                            if ((result.data.data.data[i]['timegap'] > 0) && (result.data.data.data[i]['timegap'] <= 3600)) { // 小于1小时
                                result.data.data.data[i]['timewidth'] = parseInt(result.data.data.data[i]['timegap'] / 60) + langCheck(
                                    "0000PUB-000359"
                                );
                            }
                            if ((result.data.data.data[i]['timegap'] > 3600) && (result.data.data.data[i]['timegap'] <= (3600 * 24))) { // 小于1天
                                result.data.data.data[i]['timewidth'] = parseInt(result.data.data.data[i]['timegap'] / 3600) + langCheck(
                                    "0000PUB-000360"
                                );
                            }
                            if (result.data.data.data[i]['timegap'] > (3600 * 24)) { // 1天以上
                                if (result.data.data.data[i]['businessDate'].length) {
                                    result.data.data.data[i]['timewidth'] = result.data.data.data[i]['businessDate'].split(' ')[0];
                                } else {
                                    result.data.data.data[i]['timewidth'] = '';
                                }
                                result.data.data.data[i]['dayfalg'] = true;
                            }
                        }
                        let errorlist = this.state.errorlist.concat(result.data.data.data);
                        let errorlistLength = errorlist.length;
                        let pageIndex = this.state.pageIndex - 0 + 1;

                        this.setState({
                            errorlist: errorlist,
                            loaded: true,
                            errorlistLength: errorlistLength,
                            total: result.data.data.data.length,
                            pageIndex: pageIndex
                        });
                    }
                }
                if (Object.prototype.toString.call(callback) == "[object Function]") {
                    callback();
                }
            },
            error: (res) => {
                console.log(res, '正在测试接口！');
                if (Object.prototype.toString.call(errorCallback) == "[object Function]") {
                    errorCallback();
                }
            }
        });
    }

    // 
    resethandle() {
        // let { errorFlag, changeError } = this.props;
        // changeError(!errorFlag);
    }

    // 图标点击事件
    clickHandle(e) {
        // if (this.state.total) { // 没有错误消息不显示。
        if (!this.state.visable) {
            this.showVisable();
        } else {
            this.hideVisable();
        }
        // }

    }

    //重新加载  刷新数据
    reload() {
        this.setState({ total: 0, loaded: false, errorlist: [], errorlistLength: '', lastscrollTop: 0, timer: 0, requestMoreFlag: true, pageIndex: 1 }, (prev) => {
            this.loadGridCount();
            // this.refs.erroriconlistInner.focus();
            if (this.state.visable) {
                this.loadgrid();
            }
        });
    }

    downClick(event) {
        event.stopPropagation();
    }

    componentWillMount() {
        //const {socket} = this.props;
        const _this = this;
        window.onSocketMessage = function (resMessage) {
            clearTimeout(timer1);
            timer1 = setTimeout(function () {
                _this.reload();
            }, 500);
        };
        document.addEventListener("visibilitychange", function () {
            if (document.visibilityState === 'visible') {
                _this.reload();
            }
        });
        let ENV_MERGE_TAG = getStore('ENV_MERGE_TAG');

        if (window.location.hash === "#/" || (ENV_MERGE_TAG != 'Y' && ENV_MERGE_TAG != 'N')) {
            // 判断是否显示错误中心
            Ajax({
                url: '/nccloud/platform/query/merge.do',
                data: {},
                info: {
                    name: langCheck(
                        "0000PUB-000105"
                    ) /* 国际化处理： 首页*/,
                    action: langCheck(
                        "0000PUB-000364"
                    ) /* 国际化处理： 首页加载*/,
                    appcode: "10220PLOGG"
                },
                success: (result) => {
                    if (result.data.success) {
                        setStore('ENV_MERGE_TAG', !result.data.data ? 'Y' : 'N');
                        this.setState({
                            merge: !result.data.data
                        }, () => {
                            _this.reload();
                        })
                    }
                },
                error: (res) => {
                    console.log('合盘环境判断错误', res);
                }
            })
        } else {
            this.setState({
                merge: ENV_MERGE_TAG == 'Y'
            }, () => {
                _this.reload();
            })
        }

    }

    // 点击其他地方关闭弹窗
    outsideClick = (e) => {
        let $target = e.target || e.currentTarget;
        if (!this.refs || !this.refs.erroriconlistInner) {
            return;
        }
        // console.log($target, this.refs.erroriconlistInner, this.refs.erroriconlistInner.contains($target));
        let $inner = this.refs.erroriconlistInner.querySelector('.erroriconlist-inner');
        let $icon = this.refs.erroriconlistInner.querySelector('.iconContainer');
        if ($inner && !$inner.contains($target) && !$icon.contains($target)) {
            this.hideVisable();
        }
    }

    componentDidMount() {
        let _this = this;
        // 滚动加载事件
        _this.refs.errorlist.onscroll = function () {
            clearTimeout(_this.state.timer);
            if (_this.state.requestMoreFlag) {
                _this.state.timer = setTimeout(() => {
                    let nowscrollTop = this.scrollTop;
                    if (nowscrollTop < _this.state.lastscrollTop) {
                        return false;
                    } else {
                        if (_this.state.errorlistLength * _this.state.singleLiHeight - _this.state.containerHeight - nowscrollTop < 40) {
                            if ((_this.state.pageIndex - 1) * _this.state.pageSize < _this.state.total) {// 数据都请求完了就不发了
                                _this.state.requestMoreFlag = false;
                                _this.loadgrid(function () {
                                    _this.state.requestMoreFlag = true;
                                },
                                    function () {
                                        _this.state.requestMoreFlag = true;
                                    }
                                );
                            }
                        }
                    }
                    _this.state.lastscrollTop = nowscrollTop;
                }, 300);
            }
        }

        document.addEventListener('click', this.outsideClick);
    }

    componentWillReceiveProps(props) {
        this.reload();
    }

    componentWillUnmount() {
        clearTimeout(timer1);
        clearTimeout(this.state.timer);
        document.removeEventListener("click", this.outsideClick);
    }

    render() {
        let { errorlist } = this.state;
        let mystyle = {}
        mystyle.display = this.state.total ? '' : 'none';
        if (errorlist.length) {
            errorlist = errorlist.map((e, index) => {
                return (
                    <NCDiv className="erroriconlist-item" fieldid="error" areaCode={NCDiv.config.ListItem}>
                        <table>
                            <tr>
                                <td className="info-icon"><span className={e.dayfalg ? "long" : ""}>{e.billtype_name && e.billtype_name.trim()[0]}</span></td>
                                <td>
                                    <div className="info-title-box">
                                        <span className="fr-time">{e.timewidth}</span>
                                        <span className="infor-title" alt={e.billNo}>
                                            {(e.billNo && e.billNo.trim() && (e.billNo.trim().split(',').length > 1)) ? <span className="error-nums">+{e.billNo.trim().split(',').length}</span> : null}
                                            {e.billNo && e.billNo.trim() && e.billNo.trim().split(',')[0]}
                                        </span>
                                    </div>
                                    <div className="info-content" alt={e.errorMsg_desc}>{e.errorMsg_desc}
                                    </div>
                                </td>
                            </tr>
                        </table>
                    </NCDiv>)
            })
        }
        return (
            <div
                className={`nc-workbench-hp item-wrap erroricon ${this.state.total == 0 ? 'erroricon-list-container-empty' : 'erroricon-list-container'}`}
                style={{
                    display: this.state.merge ? 'block' : 'none'
                }}
                // tabIndex='1' 
                // onBlur={this.hideVisable.bind(this)}
                ref='erroriconlistInner'
            >
                <NCTooltip
                    placement="bottom"
                    trigger="hover"
                    delayShow={500}
                    delay={1}
                    overlay={langCheck("0000PUB-000363")} //错误中心
                >
                    <div>
                        <div class="iconContainer" onClick={this.clickHandle.bind(this)}>
                            {(this.state.total == 0) ?
                                null :
                                <span className="error-num" style={mystyle}>{this.state.total}</span>}<i class="iconfont icon-cuowu2" ></i>
                        </div>
                    </div>
                </NCTooltip>
                <div className={this.state.visable ? 'erroriconlist' : 'erroriconlist lg-done'} >
                    {/* <div className="awk-icon"></div> */}
                    <NCDiv
                        // 自动化测试标记，勿删
                        fieldid="errorList"
                        areaCode={NCDiv.config.List}
                        className='erroriconlist-inner'
                        onClick={this.downClick.bind(this)}
                    >
                        <ul className="erroriconlist-ul" ref='errorlist'>
                            {errorlist}
                        </ul>
                        {this.state.total == 0 && <div className="no-data-placeholder">
                            <div className="no-data"> </div><div className="no-data-title">{langCheck(
                                "0000PUB-000365"
                            ) || '暂无数据'}</div>
                        </div>}
                        {/* 自动化测试标记 勿删 */}
                        <NCDiv areaCode={NCDiv.config.BOTTOM} className="error-bottom">
                            <table>
                                <tr>
                                    <td>
                                        <span className="look-all" onClick={() => {
                                            this.handeleSkipPage("/errorCenter", {
                                                n: langCheck(
                                                    "0000PUB-000344"
                                                ) /* 国际化处理： 错误中心*/
                                            });
                                        }}>{langCheck(
                                            "0000PUB-000362"
                                        )}</span>
                                        {/*<span className="line"></span><span className="reset-all" onClick={this.resethandle.bind(this)}>全部重试</span>*/}
                                    </td>
                                </tr>
                            </table>
                        </NCDiv>
                    </NCDiv>
                </div>
            </div>
        );
    }
}

//const ErorrCentorIconInfo = createPage({})(ErorrCentorIcon);
export default connect(
    state => ({
        errorFlag: state.appData.errorFlag
        // avatar: state.appData.avatar,
        // userName: state.appData.userName
    }),
    { changeError }
)(ErorrCentorIcon);
